module.exports = __webpack_public_path__ + "media/images/fr_ca/energize_action-0347be37118380321181c187bac99c77.png";